var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMjTitle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 346,
    height: 43,
    viewBox: "0 0 346 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M282.787 35.3811V0.498779H272.944V42.8576H290.168V35.3811H282.787Z",
    fill: "#22B7BB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M263.774 35.3811V22.9235H261.312V5.47992H258.85V0.498779H244.088V7.97526H241.626V22.9235H239.164V37.8717H236.702V42.8528H249.007V35.3763H253.926V42.8528H266.231V37.8717H263.769V35.3811H263.774ZM249.012 12.9564H253.931V27.9046H249.012V12.9564Z",
    fill: "#22B7BB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4123 35.3811V42.8576H80.7933V35.3811H73.4123Z",
    fill: "#22B7BB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M133.587 5.47992H131.125V2.98935H128.663V0.498779H116.358V2.98935H113.896V5.47992H111.434V7.97049H108.972V35.3763H111.434V37.8669H113.896V40.3575H116.358V42.848H128.663V40.3575H131.125V37.8669H133.587V35.3763H136.049V7.97526H133.587V5.47992ZM118.825 35.3811V7.97526H126.206V35.3811H118.825Z",
    fill: "#22B7BB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M342.957 2.98935V0.498779H320.814V42.8576H330.657V22.9235H335.576V42.8576H345.419V22.9235H342.957V17.9423H345.419V2.98935H342.957ZM335.576 15.447H330.657V5.47992H335.576V15.447Z",
    fill: "#22B7BB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M296.877 0.498779V42.8576H314.101V35.3811H306.72V22.9235H314.101V15.447H306.72V7.97526H314.101V0.498779H296.877Z",
    fill: "#22B7BB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M222.613 0.498779V17.9423H220.151V10.4658H217.694V2.98935H215.232V0.498779H205.389V42.8576H215.232V22.9235H217.694V30.3999H220.151V40.367H222.613V42.8576H229.994V0.498779H222.613Z",
    fill: "#22B7BB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M196.218 0.498779H174.075V42.8576H183.918V22.9235H188.837V42.8576H198.68V22.9235H196.218V17.9423H198.68V2.98935H196.218V0.498779ZM188.837 15.4517H183.918V5.47992H188.837V15.4517Z",
    fill: "#22B7BB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.242 0.498779H42.0988V42.8576H51.9418V22.9235H56.861V42.8576H66.704V22.9235H64.242V17.9423H66.704V2.98935H64.242V0.498779ZM56.861 15.4517H51.9418V5.47992H56.861V15.4517Z",
    fill: "#22B7BB"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M157.519 0.498779V35.3811H152.6V0.498779H142.757V37.8717H145.219V40.367H147.676V42.8576H162.443V40.367H164.9V37.8717H167.362V0.498779H157.519Z",
    fill: "#22B7BB"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4256 0.498779V35.3811H87.5064V42.8576H99.8066V40.367H102.269V0.498779H92.4256Z",
    fill: "#22B7BB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6236 0.498779V12.9564H15.6997V0.498779H0.937622V42.8576H10.7806V22.9235H13.2426V42.8576H23.0808V22.9235H25.5427V42.8576H35.3857V0.498779H20.6236Z",
    fill: "#22B7BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMjTitle);
export default __webpack_public_path__ + "static/media/MJTitle.be7b4352134d3323528941d0234f6faf.svg";
export { ForwardRef as ReactComponent };